import React from 'react'
import { useRoutes } from 'react-router-dom'
import { routes } from './routes'
const RenderRouter: React.FC<{}> = () => {
  let element = useRoutes([...routes])
  return element
}

export default RenderRouter
